
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"19","height":"19","fill":"#bdcccc","rx":"2"}}),_c('path',{attrs:{"stroke":"#234652","d":"M11.5 4.512c-6.5 0-8-.499-8 4.988s1.25 4.988 8 4.988zM11.5 6.507h3a.999.999 0 1 1 0 1.995h-3zM11.5 10.498h3a.999.999 0 1 1 0 1.995h-3z"}})])
          )
        }
      }
    